<template>
    <div>
        <v-card class="shortcuts" outlined>
            <v-card-title class="page-heading">
                {{ $t('allegra.shortcuts.heading') }}
            </v-card-title>

            <v-card-text class="pa-5">
                <v-form>
                    <v-text-field
                        v-for="(shortcut,index) in shortcuts"
                        :key="index"
                        v-model="shortcuts[index].value"
                        class="mb-5"
                        :label="$t(`allegra.shortcuts.${shortcut.name}`)"
                        outlined
                        hide-details
                        readonly
                        dense
                        :loading="loading && index == currentIndex"
                        :append-icon="!shortcuts[index].value ? 'fal fa-keyboard' : 'fal fa-times'"
                        @click:append="onAppendIconClick(index)"
                        @click="listenForKey(index)"
                    />
                </v-form>
            </v-card-text>
        </v-card>

        <!-- Shift Management -->
        <v-dialog
            v-model="showKeyDialog"
            max-width="400"
        >
            <div class="pa-5 white">
                <div class="text-h6 text-center mb-4">
                    {{ $t('allegra.shortcuts.press_key') }}
                </div>
                <v-alert
                    prominent
                    color="primary"
                    type="info"
                    text
                >
                    {{ $t('allegra.shortcuts.allowed_keys') }}
                </v-alert>
            </div>
        </v-dialog>
    </div>
</template>

<script>
import { loadData } from '@/views/shared/loadPageData';
import ApiService from '@/services/ApiService';

export default {
    created() {
        loadData('/admin/load/shortcuts').then(data => this.onDataLoaded(data));

        document.addEventListener('keyup', this.backgroundKeyUpHandler);
    },

    beforeDestroy() {
        document.addEventListener('keyup', this.backgroundKeyUpHandler);
    },

    data() {
        return {
            loading: false,
            showKeyDialog: false,
            currentIndex: null,
            shortcuts: []
        };
    },

    methods: {
        onDataLoaded(data) {
            this.shortcuts = data.shortcuts.filter(s => {
                if(['order_pay_order', 'order_pay_credit_card_business', 'open_drawer'].includes(s.name)) {
                    return locale === 'me'
                }

                return true
            })
        },

        listenForKey(index) {
            this.currentIndex = index
            this.showKeyDialog = true
        },

        backgroundKeyUpHandler(event) {
            if(!this.showKeyDialog) {
                return
            }

            const allowedKeyCodes = [
                'Escape', 'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12',
                'ControlLeft', 'ControlRight', 'MetaLeft', 'MetaRight', 'AltLeft', 'AltRight', 'ShiftLeft', 'ShiftRight',
                'Insert', 'Delete', 'Home', 'End', 'PageUp', 'PageDown'
            ]

            if(!allowedKeyCodes.includes(event.code)) {
                this.$snackbar(this.$t('allegra.shortcuts.not_allowed'), 'error')
                return
            }

            this.showKeyDialog = false
            this.updateShortcut(this.currentIndex, event.code)
        },

        updateShortcut(shortcutIndex, value) {
            this.currentIndex = shortcutIndex
            this.loading = true

            ApiService.patch(`/admin/shortcuts/${this.shortcuts[shortcutIndex].id}`, {
                value: value
            }).then(response => {
                this.loading = false

                const existingShortcut = this.shortcuts.find((shortcut, index) => {
                    return shortcut.value === value && index !== shortcutIndex
                })

                if(existingShortcut) {
                    existingShortcut.value = null
                }

                this.shortcuts[shortcutIndex].value = value
            })
        },

        onAppendIconClick(index) {
            if(this.shortcuts[index] && this.shortcuts[index].value) {
                this.updateShortcut(index, null)
            } else {
                this.listenForKey(index)
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.shortcuts {
    max-width: 600px;

    .page-heading {
        padding: 12px 16px;
        color: white;
        background: var(--v-primary-base);
        font-size: 16px;
        word-break: break-word;
    }
}
</style>
